import React from 'react';

type WidgetTabsLabelProps = {
    children: React.ReactNode;
};

const WidgetTabsLabel: React.FC<WidgetTabsLabelProps> = ({ children }) => {
    return <>{children}</>;
};

export default WidgetTabsLabel;
